import { hasCapability, type User } from "../base";

export const outreach = {
  read: (user: User) => hasCapability(user, "outreach.read"),
  manage: (user: User) => hasCapability(user, "outreach.manage"),
};
